/*
 * Module for the Member Age and Service report criteria page
 */
rs.module("content/reports/criteria/memberageandservicecriteria",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var planSelect = criteria.js(jsSelectors.planSelect);
            var employerSelect = criteria.js(jsSelectors.employerSelect);

            // Get Select Helper for employerSelect since we're updating its options and properties
            var employerSelectHelper = selectHelper.getHelper(employerSelect);

            planSelect.change(planChanged);

            // On plan selection change, retrieve and populate employer drop down
            function planChanged() {

                // load employers based on plan selection (all or specific)
                var selectedPlanKey = planSelect.val();

                if (selectedPlanKey == "") {
                    employerSelectHelper.loadOptionsFrom(backendUrl, null, { withBlank: true });
                }
                else {
                    employerSelectHelper.loadOptionsFrom(backendUrl, { planKey: selectedPlanKey }, { withBlank: true });
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);